import { EditorActions, EditorState, NodeTree, useEditorReturnType } from '@candulabs/craft';

import { BuiltInComponents } from 'craft/constants';
import { InsertNodeTreesAtIndex } from 'craft/hooks';

export const formInsertNodeTreesAtIndex: InsertNodeTreesAtIndex = (
  nodeTrees: NodeTree[],
  parentNodeId: string,
  insertAtIndex: number,
  editor: useEditorReturnType,
  insert: (nodeTrees: NodeTree[], parentNodeId: string, insertAtIndex: number) => void,
) => {
  const { query } = editor;

  const isFormStepNode = nodeTrees.every(
    ({ rootNodeId, nodes }: NodeTree) => nodes[rootNodeId].data.name === BuiltInComponents.FormStep,
  );

  if (isFormStepNode) {
    editor.actions.produceState((_: EditorState, actionsWithoutHistory: EditorActions) => {
      actionsWithoutHistory.resetEvents();
      const newTreeIds = nodeTrees.map((tree, i) => {
        const newTree: NodeTree = tree;
        actionsWithoutHistory.addNodeTree(newTree, parentNodeId, insertAtIndex + i);
        return newTree.rootNodeId;
      });

      actionsWithoutHistory.selectNode(newTreeIds);
    });
    return;
  }

  const visibleFormStepNodeId = query
    .node(parentNodeId)
    ?.get()
    ?.dom?.firstElementChild?.getAttribute('data-nid');

  if (!visibleFormStepNodeId) {
    return;
  }

  const lastIndexOfFormStepNodes = query.node(visibleFormStepNodeId).descendants().length;

  insert(nodeTrees, visibleFormStepNodeId, lastIndexOfFormStepNodes);
};
